import handleEnterPressEvent from '@/src/common/utilities/handleEnterPressEvent'

type IAddressNotEligibleProps = {
    setIsMultipleShipments: Function
    clearAddress: Function
}

const AddressNotEligibleForSingleShipContent = ({
    setIsMultipleShipments,
    clearAddress,
}: IAddressNotEligibleProps) => {
    return (
        <p>
            This address is not eligible to receive multiple items in a single
            shipment. All cards must ship separately. To continue,{' '}
            <a
                onClick={() => {
                    setIsMultipleShipments(true)
                }}
                onKeyDown={(e) =>
                    handleEnterPressEvent(e, () => setIsMultipleShipments(true))
                }
                tabIndex={0}
                role={'button'}
            >
                switch to individual shipments
            </a>{' '}
            or{' '}
            <a
                onClick={() => clearAddress()}
                onKeyDown={(e) => handleEnterPressEvent(e, () => clearAddress)}
                tabIndex={0}
                role={'button'}
            >
                enter a different address
            </a>
            .
        </p>
    )
}

export default AddressNotEligibleForSingleShipContent
